export function isLoggedIn() {
  // Get the access token from the cookie
  const accessToken = getCookie('aT');

  // If access token is not present, user is not logged in
  if (!accessToken) {
      return false;
  }

  // Decode the access token to get expiration time
  const decodedToken = decodeToken(accessToken);

  // Get the expiration time from the decoded token
  const expirationTime = decodedToken.exp * 1000; // Convert to milliseconds

  // Get the current time
  const currentTime = Date.now();

  // If expiration time is less than current time, token is expired
  if (expirationTime < currentTime) {
      return false;
  }

  // Token is valid and user is logged in
  return true;
}

// Helper function to get cookie value by name
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

// Helper function to decode JWT token
function decodeToken(token) {
  // Assuming token is in JWT format (header.payload.signature)
  const payload = token.split('.')[1];
  return JSON.parse(atob(payload));
}
